module.exports = __webpack_public_path__ + "static/logo-white.0fe52734.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-white.svg
// module id = 114
// module chunks = 114276838955818 263791100135453